import { useState } from "react"
import EditIcon from '@mui/icons-material/Edit';
import { Checkbox, IconButton, Input, TextField, Tooltip } from "@mui/material";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import { companyWiseEmp } from "../../actions/Companywiseclient";
import { Draggable } from "react-beautiful-dnd";
import CloseIcon from '@mui/icons-material/Close';



const DropList = ({ sortedList, setSortedList, getOnchangevalue1, finalvalue, setFinalvalue, selected, setSelected, statausValue, setStatausValue, fetchcompanyclientstatusDataList, editeValue, setEditValue, showEditValue, setShowEdite, getOnchangevalue }) => {
    // const [editeValue, setEditValue] = useState(null)
    // const [showEditValue, setShowEdite] = useState(true)

    const isSelected = (id) => selected.indexOf(id) !== -1;

    console.log(isSelected, "efgeyrfger")


    let sourceElement = null
    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
    //const [sortedList, setSortedList] = useState([])

    console.log(finalvalue, "finalvalue")




    const handleClick = (event, name) => {
        console.log(name, "eventdgweyf")
        setFinalvalue(true)
        const allnewSelected = sortedList.filter((n) => n.isUpdatable === true);
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        setSelected(newSelected);
    };

    /* change opacity for the dragged item. 
    remember the source item for the drop later */
    const handleDragStart = (event) => {
        event.target.style.opacity = 0.5
        sourceElement = event.target
        event.dataTransfer.effectAllowed = 'move'
    }

    /* do not trigger default event of item while passing (e.g. a link) */
    const handleDragOver = (event) => {
        event.preventDefault()
        event.dataTransfer.dropEffect = 'move'
    }

    /* add class .over while hovering other items */
    const handleDragEnter = (event) => {
        event.target.classList.add('over')
    }

    /* remove class .over when not hovering over an item anymore*/
    const handleDragLeave = (event) => {
        event.target.classList.remove('over')
    }

    const handleDrop = (event) => {

        console.log(event, "ehdfwedwfyed")
        /* prevent redirect in some browsers*/
        event.stopPropagation()

        /* only do something if the dropped on item is 
        different to the dragged item*/
        if (sourceElement !== event.target) {

            /* remove dragged item from list */
            const list = sortedList.filter((item, i) =>
                i.toString() !== sourceElement.id)

            /* this is the removed item */
            const removed = sortedList.filter((item, i) =>
                i.toString() === sourceElement.id)[0]

            /* insert removed item after this number. */
            let insertAt = Number(event.target.id)

            console.log('list with item removed', list)
            console.log('removed:  line', removed)
            console.log('insertAt index', insertAt)
            console.log(list, removed, insertAt, "wdgeyeyyefdwfdw")

            let tempList = []

            /* if dropped at last item, don't increase target id by +1. 
               max-index is arr.length */
            if (insertAt >= list.length) {
                tempList = list.slice(0).concat(removed)
                setSortedList(tempList)
                event.target.classList.remove('over')
            } else
                if ((insertAt < list.length)) {
                    /* original list without removed item until the index it was removed at */
                    tempList = list.slice(0, insertAt).concat(removed)

                    console.log('tempList', tempList)
                    console.log('insert the rest: ', list.slice(insertAt))

                    /* add the remaining items to the list */
                    const newList = tempList.concat(list.slice(
                        insertAt))
                    console.log('newList', newList)

                    /* set state to display on page */
                    setSortedList(newList)
                    event.target.classList.remove('over')
                }
        }
        else console.log('nothing happened')
        event.target.classList.remove('over')
    }

    const handleDragEnd = (event) => {


        event.target.style.opacity = 1
        console.log('-------------------------------------------------------------')
    }

    /* log changes in current input field */
    const handleChange = (event) => {
        event.preventDefault()
        console.log('event.target.value', event.target.value)

        /* create new list where everything stays the same except that the current
        item replaces the existing value at this index */
        const list = sortedList.map((item, i) => {
            if (i !== Number(event.target.id)) {
                return item
            }
            else return event.target.value
        })
        setSortedList(list)
    }

    /* filter list where only items with id unequal to current id's are allowed */
    // const handleDelete = (rowdata) => {
    //     console.log(rowdata, "cgdyf")

    //     //event.preventDefault()
    //     const list = sortedList.filter((item, i) =>
    //         item.id !== rowdata.id)
    //     //console.log(event.targetid.id)
    //     setSortedList(list)
    //     const data = {
    //         id: rowdata.id,
    //         hrmsCompanyId: rowdata.hrmsCompanyId,
    //         statusName: rowdata.statusName,
    //         statusPrevName: rowdata.statusPrevName,
    //         statusUpdatedName: rowdata.statusUpdatedName,
    //         isActive: rowdata.isActive,
    //         orderId: rowdata.orderId,
    //         prevOrder: rowdata.prevOrder,
    //         nextOrder: rowdata.nextOrder,
    //         createdAt: rowdata.createdAt,
    //         updatedAt: rowdata.updatedAt,
    //         prevStatusName: rowdata.prevStatusName,
    //         nextStatusName: rowdata.nextStatusName,
    //         srNo: rowdata.srNo,
    //         isFinal: finalvalue ? finalvalue : false,
    //     }
    //     companyWiseEmp.fetchDeletecompanyclientstatusmaster(data).then((response) => {
    //         if (response !== null) {
    //             fetchcompanyclientstatusDataList()
    //             alert("Delete successfully")
    //         }
    //     })
    // }

    const editeHandler = (data) => {

        console.log(data,"vhwhv")
        setStatausValue(data.statusName)
        // setStatausValue ("")
        //setShowEdite(true)
        if (editeValue === null) {
            setEditValue(data.id)
            if (data.id !== null) {
                setShowEdite(true)
            }

        }

        else {
            setEditValue(null)
            setShowEdite(false)
        }
    }
    console.log(statausValue, "dwdfwedfweydwcx")
    const EditSaveHandler = (rowdata) => {
       
        if(statausValue ===""){
            alert("Status should not be empty")
            return false

        }

        const data =
        {
            id: rowdata.id,
            hrmsCompanyId: rowdata.hrmsCompanyId,
            statusName: statausValue ? statausValue : "",
            statusPrevName: rowdata.statusPrevName,
            statusUpdatedName: rowdata.statusUpdatedName,
            isActive: rowdata.isActive,
            orderId: rowdata.orderId,
            prevOrder: rowdata.prevOrder,
            nextOrder: rowdata.nextOrder,
            createdAt: rowdata.createdAt,
            updatedAt: rowdata.updatedAt,
            prevStatusName: rowdata.prevStatusName,
            nextStatusName: rowdata.nextStatusName,
            srNo: rowdata.srNo,
            isFinal: rowdata.isFinal,
        }
        companyWiseEmp.fetchupdatecompanyclientstatus(data).then((response) => {
            if (response !== null) {
                setEditValue(null)
                setShowEdite(false)
                fetchcompanyclientstatusDataList()
                alert("Update successfully")
                setStatausValue("")

            }
        })
        
    }

    /* create list of items */
    const listItems = () => {


        return sortedList.map((item, i) => {
            const isItemSelected = isSelected(item.id);
            console.log(isItemSelected, "isItemSelected");
            const labelId = `enhanced-table-checkbox-${i}`;
            return (
                <>
                    <div key={i} className='dnd-list'>
                            <div className="item" id={i}
                                // type='text'
                                // className='input-item'
                                draggable='true'
                                onDragStart={handleDragStart}
                                onDragOver={handleDragOver}
                                onDragEnter={handleDragEnter}
                                onDragLeave={handleDragLeave}
                                onDrop={handleDrop}
                                onDragEnd={handleDragEnd}
                                // onChange={handleChange}
                                // placeholder='Enter text here'
                                value={sortedList[i]}>
                                <div className="titleValue"   >
                                    {i + 1}
                                </div>
                                <p className="titleValue"  >
                                    {item.id == null ? <TextField
                                        required
                                        id="outlined-required"
                                        label="Enter your  status"
                                        variant="standard"
                                        // sx={{width:"150px"}}
                                        name="statusName"
                                        value={item.statusName}
                                        onChange={(e) => getOnchangevalue(e, i)} /> : showEditValue === true && editeValue === item.id ?
                                        <TextField required
                                            id="outlined-required"
                                            label="Edit your  status"
                                            variant="standard"
                                            // name="statusName"
                                            value={statausValue} 
                                            onChange={(e) => setStatausValue(e.target.value)} />
                                        : item.statusName ? item.statusName : "NA"}
                                </p>
                                <p className="titleValue"  >

                                    <Checkbox
                                        color="primary"
                                        name="isFinal"
                                        value={item.isFinal}
                                        onChange={(event) => getOnchangevalue1(event, i)}
                                        checked={item.isFinal}
                                        // inputProps={{
                                        //     "aria-labelledby": labelId,
                                        // }}
                                        disabled={editeValue === item.id ? false : item.id == null ? false : true}
                                    />
                                </p>
                                <div id={i} className='delButton'  >
                                    {showEditValue === true && editeValue === item.id ?
                                        <Tooltip title="Save">
                                            <IconButton style={{ color: "green" }}>
                                                <SaveAsIcon onClick={() => EditSaveHandler(item)} />
                                            </IconButton>
                                        </Tooltip> : ""
                                    }

                                    <Tooltip title="Edit Status">
                                        <IconButton style={{ color: "green" }} onClick={() => editeHandler(item)}><EditIcon /></IconButton>
                                    </Tooltip>

                                    {/* <Tooltip title="Delete Row">
                                        <IconButton style={{ color: "red" }} onClick={() => handleDelete(item)}><DeleteForeverIcon /></IconButton>
                                    </Tooltip> */}
                                    </div>

                            </div>
                       

                    </div>
                </>
            )
        }
        )
    }


    console.log('sorted', sortedList)

    return (
        <div className='page'>
            <div className='container'>
                <div className="HeaderStatausList">
                    <p className="title">
                        S.No
                    </p>
                    <p className="title">
                        Status Name
                    </p>
                    <p className="title">
                        is Final
                    </p>
                    <p className="title">
                        Action
                    </p>

                </div>

                {/* <h1 style={{ color: "white", textAlign: "center" }}>Today</h1> */}
                {sortedList.length > 0 &&
                <>
                { listItems() }
                </>
                    }
                {/* <button className='addButton' onClick={() => newLine()}>+</button> */}

                {/* <DragItem>

                </DragItem> */}
            </div>
        </div>
    )
}

export default DropList



